module.exports = __webpack_public_path__ + "img/7.13c99dc9.jpg";